import roles from "constants/roles.constant";
import { ACCOUNT_LAYOUT_ROUTE } from "./accountPaths";
import { Account } from "../../components/modules/Account";

const { OWNER } = roles;

const accountRoutesConfig = () => ({
  path: ACCOUNT_LAYOUT_ROUTE,
  children: [
    {
      path: "",
      label: "common.account",
      component: Account,
      authorizedRoles: [OWNER],
    },
  ],
});

export default accountRoutesConfig;
